export default __webpack_public_path__ + "fonts/bda51d6ad979c41b0b4e5ca8029e426c.svg";